

export class TemperatureUpdateInput implements ITemperatureUpdateInput {
    /** The auto-generated id of the temperature master */
    selectedTemperatureId!: number;
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId!: number;
    /** The auto-generated id of the vehicle type group master */
    voltageFrom!: number;
    /** The auto-generated id of the vehicle type group master */
    voltageTo!: number;
    /** The temperature with 100 character limit */
    temperature!: string;

    constructor(data?: ITemperatureUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selectedTemperatureId = _data["selectedTemperatureId"];
            this.temperatureCalibrationId = _data["temperatureCalibrationId"];
            this.voltageFrom = _data["voltageFrom"];
            this.voltageTo = _data["voltageTo"];
            this.temperature = _data["temperature"];
        }
    }

    static fromJS(data: any): TemperatureUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selectedTemperatureId"] = this.selectedTemperatureId;
        data["temperatureCalibrationId"] = this.temperatureCalibrationId;
        data["voltageFrom"] = this.voltageFrom;
        data["voltageTo"] = this.voltageTo;
        data["temperature"] = this.temperature;
        return data; 
    }
}

export interface ITemperatureUpdateInput {
    /** The auto-generated id of the temperature master */
    selectedTemperatureId: number;
    /** The auto-generated id of the temperature calibration master */
    temperatureCalibrationId: number;
    /** The auto-generated id of the vehicle type group master */
    voltageFrom: number;
    /** The auto-generated id of the vehicle type group master */
    voltageTo: number;
    /** The temperature with 100 character limit */
    temperature: string;
}

